import { Link, useNavigate } from "react-router-dom";
import HelmetTags from "./HelmetTags";

function NotFound() {
  const navigate = useNavigate();

  return (
    <section className="not-found-page flex min-h-screen w-full flex-col items-center justify-center gap-6 px-4 py-10">
      <HelmetTags
        title="404 Not Found | Mr.Mohamed Salama"
        description="Page not found"
      />

      <img
        className="h-[52px] w-auto cursor-pointer"
        src="https://api.our-matrix.com/uploads/assets/logo.png"
        alt="Our Matrix"
        onClick={() => navigate("/")}
      />

      <div className="not-found-frame">
        <div className="not-found-card">
          <p className="not-found-code">404</p>
          <h1 className="not-found-title">Page Not Found</h1>
          <p className="not-found-text">
            The page you are looking for doesn&apos;t exist or has been moved. You
            can go back to the home page and continue from there.
          </p>

          <div className="not-found-actions">
            <Link to="/" className="not-found-btn primary">
              Go Home
            </Link>
            <button
              type="button"
              className="not-found-btn secondary"
              onClick={() => navigate(-1)}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>

      <p className="not-found-brand">Our Matrix</p>
    </section>
  );
}

export default NotFound;
